module.exports = __webpack_public_path__ + "prod/1.42.2/img/pre_img6.11fa0038.png";